import type { ComponentPropsWithRef, ReactNode } from 'react';

import { clsx } from '~/styles/utils';

import type { IconName } from '../Icon/Icon';

import { Card } from '../Card/Card';
import { IconBubble } from '../IconBubble/IconBubble';
import { Title } from '../Title/Title';
import { contentStyle, rootStyle } from './StatusCard.css';

type Props = Omit<ComponentPropsWithRef<typeof Card.Root>, 'render' | 'size' | 'variant'> & {
  children: ReactNode;
  icon: IconName;
  title: string;
};

export const StatusCard = ({ children, icon, title, ...delegated }: Props) => {
  return (
    <Card.Root {...delegated} className={clsx(rootStyle, delegated.className)} size="small" variant="primary-brand">
      <IconBubble icon={icon} />

      <div className={contentStyle}>
        <Title as="h2">{title}</Title>

        {children}
      </div>
    </Card.Root>
  );
};
